export const DATA_TESTID_ALTERNATIVE_NAVIGATION_BANNER = 'simulated-banner';
